import * as React from 'react';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ListItemButton from '@mui/material/ListItemButton';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import ClipLoader from 'react-spinners/ClipLoader';

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

class VideosList extends React.Component {
  constructor(props) {
    super(props);
    const { cookies } = props;
    this.state = {
      VideosListObject: [],
      archiveDropdownValue: {},
    };
  }

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
    onVideoSelect: instanceOf(Function).isRequired,
    selectedVideoIndex: instanceOf(Number),
    selectedVideoArchiveValue: instanceOf(String),
    backend: instanceOf(String).isRequired,
  };

  handleListItemClick = (index, videoObject) => {
    const currentArchiveValue = this.state.archiveDropdownValue[videoObject.video_ID];
    const archiveValueToPass = currentArchiveValue === undefined ? null : currentArchiveValue;

    if (this.props.selectedVideoIndex === index && archiveValueToPass === this.props.selectedVideoArchiveValue) {
      this.props.onVideoSelect(null, null, null);
    } else {
      this.props.onVideoSelect(index, videoObject, archiveValueToPass);
    }
  };

  handlePreviousRotationsListItemClick = (event, video_ID) => {
    const newArchiveDropdownValue = { ...this.state.archiveDropdownValue };
    const selectedValue = event.target.value;
    let archiveValueToPass = null;

    if (selectedValue !== 'Current') {
      newArchiveDropdownValue[video_ID] = selectedValue;
      archiveValueToPass = selectedValue;
    } else {
      newArchiveDropdownValue[video_ID] = null;
      archiveValueToPass = null;
    }
    
    this.setState({ archiveDropdownValue: newArchiveDropdownValue }, () => {
      const selectedVideoObject = this.state.VideosListObject.find(video => video.video_ID === video_ID);
      if (selectedVideoObject) {
        const selectedIndex = this.state.VideosListObject.findIndex(video => video.video_ID === video_ID);
        if (selectedIndex !== -1) {
          this.props.onVideoSelect(selectedIndex, selectedVideoObject, archiveValueToPass);
        }
      }
    });
  };

  componentDidMount() {
    if (this.props.cookies.get('code')) {
      const requestInput = {
        method: 'GET',
        headers: new Headers({
          code: this.props.cookies.get('code'),
        }),
      };

      fetch(`/api/videos/list`, requestInput)
        .then((res) => res.json())
        .then((data) => {
          this.setState(
            {
              VideosListObject: data,
            },
            () => {
              this.loadStatuses();
              this.loadArchivedRotations();
            }
          );
        });
    }
  }

  loadStatuses = () => {
    let Video_IDsArray = this.state.VideosListObject.map(
      (video) => video.video_ID
    );
    const requestInput = {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        code: this.props.cookies.get('code'),
      }),
      body: JSON.stringify({
        Video_IDsArray: Video_IDsArray,
      }),
    };

    fetch(`/api/videos/getStatuses`, requestInput)
      .then((res) => res.json())
      .then((data) => {
        const updatedVideosListObject = this.state.VideosListObject.map((element, i) => ({
          ...element,
          rotationStatus: data[i]
        }));
        this.setState({ VideosListObject: updatedVideosListObject });
      });
  };

  loadArchivedRotations = () => {
    let Video_IDsArray = this.state.VideosListObject.map(
      (video) => video.video_ID
    );

    const requestInput = {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        code: this.props.cookies.get('code'),
      }),
      body: JSON.stringify({
        Video_IDsArray: Video_IDsArray,
      }),
    };

    fetch(`/api/videos/getArchivedRotations`, requestInput)
      .then((res) => res.json())
      .then((data) => {
        let newMap = {};
        for (let index = 0; index < Video_IDsArray.length; index++) {
          newMap[Video_IDsArray[index]] = data[index];
        }
        this.setState({
          PreviousRotationsMap: newMap,
        });
      });
  };

  render() {
    const { VideosListObject = [], PreviousRotationsMap = {} } = this.state;

    return (
      <Paper style={{ height: '100%', width: '100%', overflowX: 'hidden', overflowY: 'auto' }} className="videos-list-paper">
        {this.props.cookies.get('code') ? (
          <>
            <h2 className="videos-list-title">Select a video to compare thumbnails</h2>
            <List
              sx={{ bgcolor: 'background.paper' }}
              component="nav"
            >
              {VideosListObject.length > 0 ? (
                VideosListObject.map((object, index) => (
                  <ListItemButton
                    key={object.video_ID || index}
                    selected={this.props.selectedVideoIndex === index && (this.props.selectedVideoArchiveValue === this.state.archiveDropdownValue[object.video_ID] || (this.props.selectedVideoArchiveValue === null && this.state.archiveDropdownValue[object.video_ID] === undefined))}
                    onClick={() => this.handleListItemClick(index, object)}
                    sx={{ borderBottom: '1px solid #eee' }}
                  >
                    <ListItemAvatar>
                      <Avatar 
                        src={object.thumbnail} 
                        variant="rounded" 
                        sx={{ width: 120, height: 68, marginRight: 2 }} 
                      />
                    </ListItemAvatar>
                    <ListItemText
                      primaryTypographyProps={{ fontWeight: 'medium' }}
                      primary={object.name}
                      secondary={new Date(object.date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                    />
                    <div style={{ minWidth: '100px', textAlign: 'center', padding: '0 16px' }}>
                        <span 
                            style={{ 
                                backgroundColor: '#f0f0f0', 
                                padding: '4px 8px', 
                                borderRadius: '4px',
                                fontSize: '0.85rem'
                            }}
                        >
                            {object.rotationStatus || 'N/A'}
                        </span>
                    </div>
                    <FormControl variant="standard" sx={{ m: 1, minWidth: 150 }}>
                      <Select
                        value={this.state.archiveDropdownValue[object.video_ID] === null || this.state.archiveDropdownValue[object.video_ID] === undefined ? 'Current' : this.state.archiveDropdownValue[object.video_ID]}
                        id={`prev-rotations-select-${object.video_ID}`}
                        label="Prev. Rotations"
                        onChange={(e) => this.handlePreviousRotationsListItemClick(e, object.video_ID)}
                        size="small"
                        disableUnderline
                      >
                        <MenuItem value={'Current'}>
                          Current
                        </MenuItem>
                        {PreviousRotationsMap && PreviousRotationsMap[object.video_ID] && PreviousRotationsMap[object.video_ID].length > 0 ? (
                          PreviousRotationsMap[object.video_ID].filter(Boolean).map((archivedRotationObject, index2) => (
                            <MenuItem key={index2} value={index2}>
                              {new Date(
                                archivedRotationObject?.uploadedThumbnails?.[0]?.rotationTimestamp?.[0]?.start || archivedRotationObject?.rotationTimestamp?.[0]?.start || Date.now()
                              ).toLocaleString()}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem disabled>No archived rotations</MenuItem>
                        )}
                      </Select>
                    </FormControl>
                  </ListItemButton>
                ))
              ) : (
                <div className="loader-container" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px'}}>
                  <ClipLoader
                    color={'#1976d2'}
                    loading={true}
                    size={50}
                  />
                </div>
              )}
            </List>
          </>
        ) : (
          <p>Please log in to see the videos.</p>
        )}
      </Paper>
    );
  }
}

export default withCookies(VideosList);
